//@ts-strict-ignore
import React from 'react';
import Dropdown from '../../components/connectedForm/Dropdown';
import getValue from './utils/getValue';
import { IDropdownProps } from '../../@types/dropdown';

/**
 * Wrapper class for dropdown to handle data querying.
 */

export interface IMultiStringDropdownOption {
  label?: string | null | undefined;
  value?: string | null | undefined;
}

// A bit 'hacky', but, Class here simply so that we can use instanceof when checking the
// type of objects in the array of values.
class MultiStringDropdownOption implements IMultiStringDropdownOption {
  label?: string | null | undefined;
  value?: string | null | undefined;
}

export type MultiStringDropdownProps = Omit<IDropdownProps, 'options'> & {
  value?: Array<string>;
  options: Array<IMultiStringDropdownOption>;
  onChange: (value: Array<string | null | undefined>) => {};
};

const MultiStringDropdown = (props: MultiStringDropdownProps) => {
  /**
   * Convert a list of strings into a format that the multi-select dropdown can handle.
   * @param strings - An array or comma separated string of values.
   * @returns {*} An array of IMultiStringDropdownOption objects
   */
  const getValueList = (strings: string | Array<MultiStringDropdownOption> | Array<string> | undefined) => {
    if (!strings || strings.length === 0) {
      return [];
    } else if (Array.isArray(strings) && strings[0] instanceof MultiStringDropdownOption) {
      //Already appears to be correctly formatted, return strings.
      return strings;
    } else if (Array.isArray(strings)) {
      return strings.map((value) => {
        return { value: value, label: value } as IMultiStringDropdownOption;
      });
    }
    //Return a new array of formatted values.
    return strings.split(',').map((value) => {
      return { value: value, label: value } as IMultiStringDropdownOption;
    });
  };

  const onChange = (changedValue) => {
    const values: Array<MultiStringDropdownOption> = getValue(changedValue);
    const value: Array<string | null | undefined> = values.map ? values.map((val) => val.value) : [];
    props.onChange(value);
  };

  return <Dropdown {...props} value={getValueList(props.value)} onChange={onChange} onBlur={onChange} multi={true} />;
};

export default MultiStringDropdown;
